function normalizeReceiverUser(item = {}) {
  const id = String(item.id || item.userId || '').trim();
  if (!id) return null;
  return {
    id,
    nickname: String(item.nickname || item.username || item.name || '').trim(),
    phone: String(item.phone || item.phoneNumber || '').trim()
  };
}

export function mergeReceiverUserSnapshots(currentUsers = [], nextOptions = [], receiverUserIds = []) {
  const selectedIds = Array.isArray(receiverUserIds)
    ? receiverUserIds.map((item) => String(item || '').trim()).filter(Boolean)
    : [];
  const optionMap = new Map();

  (Array.isArray(currentUsers) ? currentUsers : []).forEach((item) => {
    const normalized = normalizeReceiverUser(item);
    if (!normalized) return;
    optionMap.set(normalized.id, normalized);
  });

  (Array.isArray(nextOptions) ? nextOptions : []).forEach((item) => {
    const normalized = normalizeReceiverUser(item);
    if (!normalized) return;
    optionMap.set(normalized.id, normalized);
  });

  return selectedIds
    .map((id) => optionMap.get(id))
    .filter((item) => item && item.id);
}
